<template>
    <div>
        <v-card color="#EDF1F3">
        <v-layout align-center justify-start style="padding-inline-start: 20px">
          <v-flex xs3>
            <div class="headline">
              {{ $t("seasonalPage.dateLabel") }}
              {{this.term.created_at ? $companyTime(term.created_at, " DD MMM YYYY HH:mm") : $t('seasonalPage.noDataAvailable')}}
            </div>
            <div style="color: #8599a3">
                    <b
                      ><a href="#" @click="openDoc(term.file_url)"
                        >{{ $t("seasonalPage.openFile") }}</a
                      ></b
                    >
            </div>
                
          </v-flex>
          <v-flex xs8> </v-flex>
        </v-layout>
      </v-card>
      <v-btn color="primary" dark class="mb-2 hbtn" to="/terms_and_conditions/create"
        >{{ $t("seasonalPage.newButton") }}</v-btn
      >
      <v-data-table :headers="headers" :items="responses" :loading="loading">
                  <template v-slot:items="props">
                    <tr :class="[props.item.response == 'ACCEPT' ? 'accept' : 'reject']">
                      <td class="text-xs-start">{{ props.item.username }}</td>
                      <td class="text-xs-start">{{ `${props.item.first_name} ${props.item.last_name}` }}</td>
                      <td class="text-xs-start">{{ !props.item.response ? 'NO_RESPONSE' :  props.item.response}}</td>
                      <td class="text-xs-start">{{ $companyTime(props.item.created_at, "DD-MM-YYYY HH:mm:ss") }}</td>
                    </tr>
                  </template>
        </v-data-table>
    </div>
  </template>
  
  <style lang="scss">
  .hbtn {
    float: inline-end;
    z-index: 1;
    margin-top: 20px;
    margin-inline-end: 20px;
    padding: 0px 45px;
  }
  .open {
  margin-bottom: 15px;
  margin-inline-start: 35px;
}
.reject {
  td {
      background-color: rgba(220, 39, 39, 0.08);
      border-radius: 4px;
      color: rgb(220, 39, 39);
  }
}
  .accept {
  td {
      background-color: rgba(99, 228, 24, 0.08);
      border-radius: 4px;
      color: rgb(5, 116, 51);
  }
}
  </style>
  
  <script>
  import DataTable from "@/components/monaco/DataTable";
  import moment from "moment";
  
  export default {
    name: "TermsAndConditions",
    title() {
      return this.$t("seasonalPage.termsPageTitle");
    },
    components: { DataTable },
    data() {
      return {
        responses: [],
        term: {},
        loading: true,
      };
    },

    computed: {
      headers() {
        return [
          { text: this.$t("seasonalPage.captainUsername"), value: 'captain_id' },
          { text: this.$t("seasonalPage.captainName"), value: 'captain_id' },
          { text: this.$t("seasonalPage.answer"), value: 'response' },
          { text: this.$t("seasonalPage.answeredAt"), value: 'created_at' },
        ];
      },
    },
    methods: {
        openDoc(value) {
      window.open(this.api.GET_TERM(value), "_blank");
    },
    },
    mounted() {
        this.axios.get(this.api.ACTIONS.TERMS).then(({ data }) => {
      this.term = data.data;
      this.responses = data.data.responses;
      console.log('data');
      console.log(data);
    }).then(()=>{ this.loading = false;}).catch((err) => {
          console.log(err.message);
          this.loading = false;
        });
    },
  };
  </script>
  